document.addEventListener("DOMContentLoaded", function () {
    // Check if .Benefits section exists before executing the script
    const benefitsSection = document.querySelector(".Benefits");
    if (!benefitsSection) return;

    // Create the popup container dynamically
    const popup = document.createElement("div");
    popup.classList.add("popup-modal");
    popup.innerHTML = `
        <div class="popup-content">
            <span class="popup-close">&times;</span>
            <div class="popup-header">
                <h3 class="popup-title"></h3>
            </div>
            <p class="popup-text"></p>
        </div>
    `;
    document.body.appendChild(popup);

    const popupTitle = popup.querySelector(".popup-title");
    const popupText = popup.querySelector(".popup-text");
    const popupClose = popup.querySelector(".popup-close");

    // Benefit Data: title & description (NO ICON for the first 3 items)
    const benefitData = {
        "Skin-Friendly & Lasting Shine": {
            description: "Experience jewelry that cares as much as you do. Our pieces are designed to be kind to sensitive skin and resist tarnishing, ensuring that every treasure remains as radiant as the moments you celebrate. Indulge in lasting elegance that reflects your timeless beauty."
        },
        "Timeless Jewelry for Life's Moments": {
            description: "Celebrate every milestone with jewelry that captures the essence of your journey. Each piece is a handmade treasure, crafted with exquisite care to echo the beauty of your most cherished memories. Let our collection be the elegant reflection of your unique story."
        },
        "30-Day Money Back Guarantee": {
            description: "We understand that buying jewelry online can feel uncertain—what if it doesn’t live up to your expectations, or simply isn’t the perfect reflection of your style? That’s why we offer a 30-day money back guarantee. If your chosen piece doesn’t capture your heart or match the elegance you deserve, simply return it—no questions asked, no hassle, and with no extra cost to you. We believe in creating treasures that celebrate your unique journey, and your satisfaction is our lasting promise."
        }
    };

    // Use event delegation to handle clicks on dynamically loaded elements
    document.body.addEventListener("click", function (event) {
        const benefitItem = event.target.closest(".BenefitItem");

        if (benefitItem) {
            const benefitTextElement = benefitItem.querySelector(".BenefitItem__Text");

            if (benefitTextElement) {
                const benefitText = benefitTextElement.innerText.trim();

                // Open popup only if the clicked item is in the benefitData object
                if (benefitData[benefitText]) {
                    popupTitle.innerText = benefitText;
                    popupText.innerText = benefitData[benefitText].description;
                    popup.style.display = "flex";
                }
            }
        }
    });

    // Close popup when clicking the close button
    popupClose.addEventListener("click", function () {
        popup.style.display = "none";
    });

    // Close popup when clicking outside the content box
    popup.addEventListener("click", function (event) {
        if (event.target === popup) {
            popup.style.display = "none";
        }
    });
});
